import React from 'react';
import { ReactComponent as ReverseLogoSVG } from '@/assets/images/winbeatNextReverseLogo.svg';
import { alpha, Box, Stack, Typography, useTheme } from '@mui/material';

const WinbeatReverseLogo = ({ width = 110, color = '#ffffff', ...props }) => (
	<Box
		component={ReverseLogoSVG}
		sx={{ width: `${width}px`, height: 'auto', display: 'block', color, ...props }}
	/>
);

export const IntegratedWithWinbeat = ({ variant }) => {
	const theme = useTheme();
	const onDark = variant === 'dark';

	const lightenedText = onDark
		? alpha(theme.palette.folioWhite, 0.12)
		: alpha(theme.palette.darkModePaper, 0.12);

	const colour = onDark
		? alpha(theme.palette.folioWhite, 0.45)
		: alpha(theme.palette.darkModePaper, 0.45);

	return (
		<Stack direction='column' alignItems='center' spacing={1}>
			<Stack direction='row' alignItems='center' spacing={1} sx={{ width: '100%' }}>
				<Box
					sx={{
						flexGrow: 1,
						height: '1px',
						backgroundColor: lightenedText,
					}}
				/>
				<Typography
					sx={{
						fontSize: '9px',
						fontWeight: 600,
						textTransform: 'uppercase',
						letterSpacing: '0.14em',
						color: colour,
						whiteSpace: 'nowrap',
					}}
				>
					Integrated with
				</Typography>
				<Box
					sx={{
						flexGrow: 1,
						height: '1px',
						backgroundColor: lightenedText,
					}}
				/>
			</Stack>
			<WinbeatReverseLogo
				width={80}
				{...(!onDark && { color: theme.palette.darkModePaper })}
			/>
		</Stack>
	);
};

export default WinbeatReverseLogo;
